import React from 'react';
import {Link} from '@reach/router';

import * as styles from './PlainButton.module.css';

export function PlainButton({children, ...props}) {
  if (props.to) {
    return (
      <Link className={styles.PlainButton} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" className={styles.PlainButton} {...props}>
      {children}
    </button>
  );
}
